import styled from 'styled-components';
import { fontSizeMedium } from 'assets/styles/fonts';

export const Container = styled.div`
  text-align: center;
  position: relative;
  width: 100%;
  height: 50px;
  ${fontSizeMedium};
`;

export const Text = styled.span`
  display: inline-block;
  font-style: italic;
  padding: 0 10px;
`;

export const Logo = styled.span`
  background: #fff url('https://wi-q.cloud/i/30x30/wi-q/logo/standard.jpg');
  height: 30px;
  width: 30px;
  display: inline-block;
  position: relative;
  top: 10px;
`;
